import { isPlatformBrowser } from '@angular/common'
import { Component, computed, inject, PLATFORM_ID } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { ActivatedRouteSnapshot, NavigationEnd, Router, RouterOutlet } from '@angular/router'

import { filter, map } from 'rxjs'

import { FooterComponent } from 'app/_layout/footer/footer.component'
import { NavbarComponent } from 'app/_layout/navbar/navbar.component'
import { AppConfigService } from 'app/app-config.service'

@Component({
  selector: 'app-home',
  imports: [RouterOutlet, FooterComponent, NavbarComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  appConfigService = inject(AppConfigService)
  router = inject(Router)
  platformId = inject(PLATFORM_ID)
  config = this.appConfigService.getAppConfig
  private readonly activeRoute = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.router.routerState.snapshot.root)
    ),
    { initialValue: this.router.routerState.snapshot.root }
  )
  readonly usePageBackground = computed(() => {
    let route: ActivatedRouteSnapshot | null = this.activeRoute()
    let usePageBackground = true

    while (route) {
      const preference: unknown = route.data['usePageBackground']
      if (typeof preference === 'boolean') {
        usePageBackground = preference
      }
      route = route.firstChild
    }

    return usePageBackground
  })

  constructor() {
    if (this.router.url === '') {
      this.router.navigate([''])
    }
    if (!this.config) {
      if (isPlatformBrowser(this.platformId)) {
        this.router.navigate(['/under-construction'])
      }
    }
  }
}
